import {
    BorderNoneRegular,
    CheckmarkCircleColor,
    CircleHintFilled,
    ErrorCircleFilled,
    GlobeLocationRegular,
    GlobeRegular,
    LinkMultipleFilled,
    MailCopyRegular,
    NumberSymbolRegular,
    PersonSearchRegular,
    PresenceUnknownRegular,
    WarningFilled,
} from "@fluentui/react-icons";


export const threatResultConfig = {

    // url
    urls: {
        icon: LinkMultipleFilled,
        title: "URLs",
    },
    url: {
        icon: LinkMultipleFilled,
        title: "URLs",
    },

    // email
    email_addresses: {
        icon: MailCopyRegular,
        title: "Email Addresses",
    },
    email: {
        icon: MailCopyRegular,
        title: "Email Addresses",
    },

    username: {
        icon: PersonSearchRegular,
        title: "Username",
    },

    // domain
    domains: {
        icon: GlobeRegular,
        title: "Domains",
    },
    domain: {
        icon: GlobeRegular,
        title: "Domains",
    },

    // ip
    ipv4s: {
        icon: MailCopyRegular,
        title: "IP Address",
    },
    ip: {
        icon: GlobeLocationRegular,
        title: "IP Address",
    },

    // hash
    sha256s: {
        icon: MailCopyRegular,
        title: "SHA256",
    },
    hash: {
        icon: NumberSymbolRegular,
        title: "Hash",
    },

    hostname: {
        icon: GlobeLocationRegular,
        title: "Hostname",
    },

    default: {
        icon: CircleHintFilled,
        title: "",
    },

} as const;

export type ThreatResultType = keyof typeof threatResultConfig;

export const threatConfig = {
    Malicious: {
        title: "Malicious",
        color: "#BC1947",
        icon: WarningFilled,
        bgcolor: "#BC194710",

    },
    Suspicious: {
        title: "Suspicious",
        color: "#D93C01",
        icon: ErrorCircleFilled,
        bgcolor: "#D93C0110",
    },
    Unrated: {
        title: "Unrated",
        color: "#616161",
        icon: BorderNoneRegular,
        bgColor: "#61616110",
    },
    Clean: {
        title: "Clean",
        color: "#127D44",
        icon: CheckmarkCircleColor,
        bgColor: "#127D4410",
    },
    UNKNOWN: {
        color: "#616161",
        title: "Unknown",
        icon: PresenceUnknownRegular,
        bgColor: "#61616110",

    },
    ERROR_NORMALIZING: {
        color: "#616161",
        title: "Error Normalizing",
        icon: ErrorCircleFilled,
        bgColor: "#61616110",
    },
    NOT_APPLICABLE: {
        title: "Not Applicable",
        color: "#616161",
        icon: PresenceUnknownRegular,
        bgColor: "#61616110",
    },

    default: {
        title: "Unknown",
        color: "#616161",
        icon: PresenceUnknownRegular,
        bgColor: "#61616110",
    },

} as const;

export type ThreatType = keyof typeof threatConfig;
